<template functional>
  <div
    :class="[
      data.staticClass,
      data.class,
      $style.container,
      $kindStyle[props.kindClass],
      $sizeStyle[props.sizeClass],
      $alignStyle[props.textAlign],
    ]"
  >
    <h3 :class="$style.heading" v-if="$slots.heading">
      <slot name="heading" />
    </h3>
    <slot />
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'AtomAlert',
  props: {
    kindClass: {
      type: String,
      required: false,
      default: 'primary',
    },
    sizeClass: {
      type: String,
      required: false,
      default: 'small',
    },
    textAlign: {
      type: String,
      required: false,
      default: 'left',
    },
  },
});
</script>

<style lang="scss" module>
.container {
  border-radius: $BORDER_RADIUS_INNER;

  hr {
    margin: 12px 0;
  }

  a,
  strong {
    font-weight: bold;
    color: inherit;
  }

  a {
    text-decoration: underline;
  }

  a:hover {
    text-decoration: none;
  }

  p:not(:last-child),
  ul:not(:last-child),
  ol:not(:last-child) {
    margin-bottom: 10px;
  }
}

.heading {
  font-weight: bold;

  &:not(:last-child) {
    padding-bottom: 12px;
    margin-bottom: 12px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
  }
}
</style>

<!-- styles by props -->
<style lang="scss" module="$kindStyle">
.primary {
  color: $COLOR_PRIMARY_DEEP;
  background: $COLOR_PRIMARY_PALE;

  hr {
    border-color: $COLOR_PRIMARY;
  }

  .heading {
    border-color: $COLOR_PRIMARY;
  }
}

.attention {
  color: $COLOR_ATTENTION_DEEP;
  background: $COLOR_ATTENTION_PALE;

  hr {
    border-color: $COLOR_ATTENTION;
  }

  .heading {
    border-color: $COLOR_ATTENTION;
  }
}

.secondary {
  color: $COLOR_SECONDARY_DEEP;
  background: $COLOR_SECONDARY_PALE;

  hr {
    border-color: $COLOR_SECONDARY;
  }

  .heading {
    border-color: $COLOR_SECONDARY;
  }
}
</style>

<style lang="scss" module="$sizeStyle">
.small {
  @include font(14, regular, note);
  padding: 15px 20px;
}

.large {
  @include font(15, regular, note);
  padding: 25px 35px;
}
</style>

<style lang="scss" module="$alignStyle">
.left {
  text-align: left;
}

.center {
  text-align: center;

  h2,
  h3,
  h4,
  p {
    text-align: center;
  }
}
</style>
